import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  orTextParent: {
    textAlign: 'center',
    position: 'relative',
    marginTop: '24px',
    width: '100%',
    '&::before': {
      position: 'absolute',
      content: '""',
      width: '70%',
      height: '1px',
      left: '50%',
      top: '58%',
      transform: 'translate(-50%, -50%)',
      borderTop: `1px dashed ${STYLE.COLOR.DIVIDER}`,
    },
  },
  orText: {
    padding: '0 6px',
    position: 'relative',
    zIndex: 1,
    background: STYLE.COLOR.WHITE,
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT1,
  },
}));
